import React from "react";
import { View } from "react-native";

import { useNavigation } from "@react-navigation/core";

import HeaderDefault from "../../components/HeaderDefault";

import CryptoListSelection from "../../components/CryptoListSelection";

const WithdrawCryptoSelection = () => {
  const navigation = useNavigation();

  function onCryptoSelected(crypto) {
    navigation.navigate({ name: 'WithdrawCrypto', params: { crypto } });
  }

  return (
    <View>
      <HeaderDefault title="Sacar" />

      <CryptoListSelection onItemPressed={onCryptoSelected} />
    </View>
  );
};

export default WithdrawCryptoSelection;
